export default __webpack_public_path__ + "static/media/online-community.ad359020.svg";